<div class="d-flex flex-wrap">
  <ng-container *ngFor="let item of legend; let i = index">
    <div class="chart-chip" [ngClass]="{'inactive': item.inactive}" [ngStyle]="{'backgroundColor': colors[i % colors.length]}"
      (click)="toggleItem(item)">
      <p>{{ item.name }}</p>
    </div>
  </ng-container>
</div>